// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import CarouselController from './carousel_controller.js';
application.register('carousel', CarouselController);

import CategorySelectController from './category_select_controller';
application.register('category-select', CategorySelectController);

import CompareController from './compare_controller.js';
application.register('compare', CompareController);

import CompareDraggableController from './compare_draggable_controller.js';
application.register('compare-draggable', CompareDraggableController);

import FinishCarouselController from './finish_carousel_controller';
application.register('finish-carousel', FinishCarouselController);

import ModelController from './model_controller';
application.register('model', ModelController);

import OffcanvasController from './offcanvas_controller.js';
application.register('offcanvas', OffcanvasController);

import ProductCarouselController from './product_carousel_controller.js';
application.register('product-carousel', ProductCarouselController);

import RevealController from './reveal_controller.js';
application.register('accordion-reveal', RevealController);

import Reveal from 'stimulus-reveal-controller';
application.register('reveal', Reveal);

import ScrollController from './scroll_controller.js';
application.register('scroll', ScrollController);

import VectorMapController from './vectormap_controller.js';
application.register('vectormap', VectorMapController);

import YoutubeController from './youtube_controller.js';
application.register('youtube', YoutubeController);
